const languages = {
    en: {
        fontFamily: '',
        fontSize: '14px',
        label: 'En',
        code: 'en',
        placeholder: 'Search Location',
        restaurantCountText: (selectedLocation, filteredDataLength) =>
            `${filteredDataLength} restaurants in and around '${selectedLocation || 'Sri Lanka'}'`,
        defaultLocation: 'Sri Lanka',
        locationFontSize: '12px',
        website: 'Website',
        directions: 'Directions',
        phone: 'Hotline',
        page: 'Page',
    },
    lk: {
        fontFamily: "IskoolaPota",
        fontSize: '16px',
        label: 'සිං',
        code: 'lk',
        placeholder: 'ස්ථානයක් සොයන්න',
        restaurantCountText: (selectedLocation, filteredDataLength) =>
            `'${selectedLocation || 'ශ්‍රී ලංකාව'}' ඇතුළත අවන්හල් ${filteredDataLength} ඇත`,
        defaultLocation: 'ශ්‍රී ලංකාව',
        locationFontSize: '14px',
        website: 'වෙබ් අඩවිය',
        directions: 'ගූගල් සිතියම ',
        phone: 'දුරකථන අංකය',
        page: 'පිටුව',
    },
};

export default languages;
